export const sameValueStringOrArray = (value1: string | Array<string>, value2: string | Array<string>): boolean => {
    if (Array.isArray(value1) && Array.isArray(value2)) {
        return value1.filter((v1) => value2.includes(v1)).length > 0
    }
    if (Array.isArray(value1) && !Array.isArray(value2)) {
        return value1.includes(value2)
    }
    if (Array.isArray(value2) && !Array.isArray(value1)) {
        return value2.includes(value1)
    }
    return value1 === value2
}
